import { render, staticRenderFns } from "./ProTipDialog.vue?vue&type=template&id=508e334a"
import script from "./ProTipDialog.vue?vue&type=script&lang=js"
export * from "./ProTipDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports